import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'hub-modal-header',
  templateUrl: './hub-modal-header.component.html',
  styleUrls: ['./hub-modal-header.component.scss']
})
export class HubModalHeaderComponent {

  @Input() headerText: string;
  @Input() headerSubText: string;
  @Input() activeModal: NgbActiveModal;


  ngOnInit() {

  }
}